<div class="col-md-12 noBottomMargin noPaddingMd-12 borderDiv" >
  <div class="col-md-12 contactBreadCrumbDiv">
    <ol class="breadcrumb">
      <li><a href="#" >{{ 'global.menu.home'|translate }}</a></li>
      <li class="active">{{ 'global.menu.contact'|translate }}</li>
    </ol>
  </div>
  <div class="col-md-12 outerAccordion">
    <div class="col-md-12 noPaddingMd-12 accordionDiv">
      <div class="accordion js-accordion" role="tablist" aria-multiselectable="true">
        <div class="panel emplyPanel">

          &nbsp;
        </div>
        <div class="panel">
          <div class="accordion-panel-heading" data-toggle="collapse" data-parent=".js-accordion" data-target=".js-collapse-0" role="tab">
            PT Asuransi Allianz Life Indonesia
          </div>
          <div class="accordion-panel-collapse collapse in js-collapse-0"  role="tabpanel">
            <div class="accordion-panel-body">
              <div class="col-md-12 contactMainContent">
              <div class="col-md-12 noPaddingMd-12 contactSubContent">
                  <div class="col-md-4">
                    {{'contact.contacttable.address' | translate}}
                  </div>
                  <div class="col-md-8">
                    World Trade Centre 3 & 6, Jl. Jend. Sudirman Kav.29 - 31, Jakarta Selatan 12920
                  </div>
                </div>
                <div class="col-md-12 noPaddingMd-12 contactSubContent">
                  <div class="col-md-4">
                    {{'contact.contacttable.email' | translate}}
                  </div>
                  <div class="col-md-8">
                    <a style="color: #199dd7" href="mailto:Azlife-EBPensionAdministration3@allianz.co.id" target="_top">Azlife-EBPensionAdministration3@allianz.co.id</a>
                  </div>
                </div>
                <div class="col-md-12 noPaddingMd-12 contactSubContent">
                  <div class="col-md-4">
                    {{'contact.contacttable.phone' | translate}}
                  </div>
                  <div class="col-md-8">
                    (021) 1500 136
                  </div>
                </div>
                <div class="col-md-12 noPaddingMd-12 contactSubContent">
                  <div class="col-md-4">
                    {{'contact.contacttable.fax' | translate}}
                  </div>
                  <div class="col-md-8">
                    (021) 29268080
                  </div>
                </div>
                <div class="col-md-12 noPaddingMd-12 contactSubContentFinal">
                  <div class="col-md-4">
                    Office Hours
                  </div>
                  <div class="col-md-8">
                    07:00 – 17:00
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div class="panel emptyPanel2">

          &nbsp;
        </div>
      </div>
    </div>
  </div>
  </div>
